<script>
import Vue from 'vue';

export default {
    name: 'list-group',

    props: {
        type: {
            type: String,
            default: 'link'
        }
    },

    computed: {
        objectClass() {
            return [
                'list-group',
                this.class
            ]
        },

        element() {
            if (this.type === 'list') {
                return 'ul'
            }

            return 'div';
        }
    }
}
</script>

<template>
    <component :is="element" :class="objectClass">
        <slot></slot>
    </component>
</template>